import Marquee from "react-fast-marquee";
import { MARQUEE } from "../data";

export const EditorialMarquee = () => (
  <section
    className="relative border-y border-black/10 bg-white py-10"
    data-testid="marquee-section"
    aria-hidden="true"
  >
    <Marquee speed={38} gradient gradientColor="#ffffff" gradientWidth={160}>
      {MARQUEE.concat(MARQUEE).map((item, i) => (
        <div key={i} className="flex items-center">
          <span className="px-10 font-sans text-5xl font-light tracking-tight text-transparent [-webkit-text-stroke:1px_rgba(0,0,0,0.18)] md:text-7xl">
            {item}
          </span>
          <span className="h-2 w-2 rounded-full bg-[var(--accent)]/80 shadow-[0_0_12px_rgba(36,86,255,0.5)]" />
        </div>
      ))}
    </Marquee>
  </section>
);
